import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core/";
import { makeStyles } from "@material-ui/core/styles";
import { Dashboard, Schedule } from "@material-ui/icons/";
import clsx from "clsx";
import { ROOT } from "navigation/CONSTANTS";
import { DSCView as DSCPage } from "./components";
import DrawerFooter from "components/DrawerFooter";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Route, useHistory } from "react-router-dom";

const drawerWidth = 270;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    overflow: "auto",
  },
  paperStyle: {
    top: "unset",
    height: `calc(100% - 100px)`,
    border: "none",
  },
}));

export default function DSCView() {
  const classes = useStyles();
  const { dscDrawerOpen } = useSelector((state) => state.appConfig);
  const [selected] = useState(1);
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      {/* <CssBaseline /> */}
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: dscDrawerOpen,
          [classes.drawerClose]: !dscDrawerOpen,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: dscDrawerOpen,
            [classes.drawerClose]: !dscDrawerOpen,
          }),
        }}
        PaperProps={{ className: classes.paperStyle }}
      >
        {/* <div> */}
        <List>
          <ListItem button onClick={() => history.push(ROOT)}>
            <ListItemIcon>
              <Dashboard />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{ noWrap: true }}
              primary={t("pgReview.tlDashboard")}
            />
          </ListItem>

          <ListItem button selected={selected == 1}>
            <ListItemIcon>
              <Schedule />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{ noWrap: true }}
              primary={t("other.dscTitle")}
            />
          </ListItem>
        </List>
        <DrawerFooter />
        {/* </div> */}
      </Drawer>
      <main className={classes.content}>
        <Route path="/dsc" exact>
          <DSCPage />
        </Route>
      </main>
    </div>
  );
}
